import { useState } from 'react';

import './password-input.css';

/**
 * A password field with a show/hide toggle.
 *
 * The toggle is a real button, labelled for a screen reader, and defaults to hidden — a password is
 * masked until someone chooses to see it. Revealing it is often the difference between a typo and a
 * locked-out person, which is exactly why it exists.
 */
export interface PasswordInputProps {
  readonly id?: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly autoComplete?: string;
  readonly placeholder?: string;
}

export function PasswordInput({ id, value, onChange, autoComplete, placeholder }: PasswordInputProps) {
  const [shown, setShown] = useState(false);

  return (
    <span className="password">
      <input
        id={id}
        className="begin__input password__input"
        type={shown ? 'text' : 'password'}
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        type="button"
        className="password__toggle"
        aria-pressed={shown}
        aria-label={shown ? 'Hide password' : 'Show password'}
        onClick={() => setShown((current) => !current)}
      >
        {shown ? 'Hide' : 'Show'}
      </button>
    </span>
  );
}
